
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ebXC", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $bYRk6 = parcelRequire("bYRk6");


var $ffCOo = parcelRequire("ffCOo");


var $dYBVS = parcelRequire("dYBVS");


var $1OLls = parcelRequire("1OLls");


var $5l1kQ = parcelRequire("5l1kQ");


var $cUycv = parcelRequire("cUycv");


var $bSKDV = parcelRequire("bSKDV");


var $b7FrM = parcelRequire("b7FrM");


var $d925B = parcelRequire("d925B");

var $55QXP = parcelRequire("55QXP");


var $59U23 = parcelRequire("59U23");


var $7nUdN = parcelRequire("7nUdN");


var $fGYGE = parcelRequire("fGYGE");

var $4i54r = parcelRequire("4i54r");

var $1xbL9 = parcelRequire("1xbL9");


var $ancN7 = parcelRequire("ancN7");


var $hXhSb = parcelRequire("hXhSb");


var $21K7m = parcelRequire("21K7m");


var $3h7Ko = parcelRequire("3h7Ko");

function $9e8c139d238b6fc2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9e8c139d238b6fc2$var$linkStyle = {
    name: "14m5vmv",
    styles: "position:absolute;background:transparent;top:0;right:0;bottom:0;left:0;cursor:pointer;width:100% !important;height:100% !important"
};
const $9e8c139d238b6fc2$var$borderStyle = {
    name: "10uwk9w",
    styles: "position:absolute;width:100% !important;height:100% !important"
};
const $9e8c139d238b6fc2$var$MediaBorder = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
    const borderColor = mark?.attrs.color ?? '';
    const borderWidth = mark?.attrs.size ?? 0;
    const paletteColorValue = (0, $bSKDV.hexToEditorBorderPaletteColor)(borderColor) || borderColor;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-mark-type": "border",
        "data-color": borderColor,
        "data-size": borderWidth,
        css: $9e8c139d238b6fc2$var$borderStyle,
        style: {
            borderRadius: `${borderWidth}px`,
            boxShadow: `0 0 0 ${borderWidth}px ${paletteColorValue}`
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1OLls.MediaBorderGapFiller), {
        borderColor: borderColor
    }), children);
};
const $9e8c139d238b6fc2$var$MediaLink = ({ mark: mark, children: children, onClick: onClick })=>{
    if (!mark) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
    const linkHref = mark?.attrs.href;
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, $9K4OG.jsx)("a", {
        href: linkHref,
        rel: "noreferrer noopener",
        onClick: onClick,
        "data-block-link": linkHref,
        css: $9e8c139d238b6fc2$var$linkStyle
    }, children));
};
const $9e8c139d238b6fc2$var$MediaAnnotation = ({ mark: mark, children: children })=>{
    if (!mark) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7nUdN.default), {
        id: mark.attrs.id,
        annotationType: mark.attrs.annotationType,
        dataAttributes: {
            'data-renderer-mark': true,
            'data-block-mark': true
        },
        // This should be fine being empty [] since the serializer serializeFragmentChild getMarkProps call always passes
        annotationParentIds: [],
        allowAnnotations: true,
        useBlockLevel: true
    }, children);
};
const $9e8c139d238b6fc2$var$MediaAnnotations = ({ marks: marks = [], children: children })=>{
    // Early Exit
    if (marks.length === 0) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children);
    // Recursive marks
    const currentMark = marks[0];
    const otherMarks = marks.slice(1);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, /*#__PURE__*/ (0, $9K4OG.jsx)($9e8c139d238b6fc2$var$MediaAnnotation, {
        key: currentMark.attrs.id,
        mark: currentMark
    }, otherMarks.length ? /*#__PURE__*/ (0, $9K4OG.jsx)($9e8c139d238b6fc2$var$MediaAnnotations, {
        marks: otherMarks
    }, children) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, children)));
};
const $9e8c139d238b6fc2$var$CommentBadgeWrapper = ({ marks: marks, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false, ...rest })=>{
    const [status, setStatus] = (0, $42omo.useState)('default');
    const [entered, setEntered] = (0, $42omo.useState)(false);
    const updateSubscriber = (0, $hXhSb.useInlineCommentSubscriberContext)();
    const activeParentIds = (0, $ancN7.useInlineCommentsFilter)({
        annotationIds: marks?.map((mark)=>mark.attrs.id) ?? [
            ''
        ],
        filter: {
            state: (0, $cUycv.AnnotationMarkStates).ACTIVE
        }
    });
    (0, $42omo.useEffect)(()=>{
        const observer = new MutationObserver((mutationList)=>{
            mutationList.forEach((mutation)=>{
                const parentNode = mutation.target.parentNode;
                if (mutation.attributeName === 'data-has-focus') {
                    const isMediaCaption = parentNode?.closest('[data-media-caption="true"]');
                    const elementHasFocus = parentNode?.querySelector('[data-has-focus="true"]') && !isMediaCaption;
                    elementHasFocus ? setStatus('active') : setStatus('default');
                }
            });
        });
        if (mediaSingleElement) observer.observe(mediaSingleElement, {
            attributes: true,
            subtree: true,
            attributeFilter: [
                'data-has-focus'
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaSingleElement,
        setStatus
    ]);
    if (!isDrafting && !activeParentIds.length) return null;
    const onClick = (e)=>{
        e.preventDefault();
        if (updateSubscriber) updateSubscriber.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: activeParentIds,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            eventTarget: e.target,
            // use mediaSingle here to align with annotation viewed event dispatched in editor
            eventTargetType: 'mediaSingle',
            viewMethod: (0, $55QXP.VIEW_METHOD).BADGE
        });
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fGYGE.CommentBadgeNext), {
        onMouseEnter: ()=>setEntered(true),
        onMouseLeave: ()=>setEntered(false),
        status: entered ? 'entered' : status,
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        ...rest
    });
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $9e8c139d238b6fc2$var$Media extends (0, $42omo.PureComponent) {
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.renderCard();
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dYBVS.WithProviders), {
            providers: [
                'mediaProvider',
                'contextIdentifierProvider'
            ],
            providerFactory: providers,
            renderNode: this.renderCard
        });
    }
    constructor(props){
        super(props);
        this.handleMediaLinkClickFn = void 0;
        this.renderCard = (providers = {})=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = providers;
            const { allowAltTextOnImages: allowAltTextOnImages, alt: alt, featureFlags: featureFlags, shouldOpenMediaViewer: allowMediaViewer, enableDownloadButton: enableDownloadButton, ssr: ssr, width: width, height: height, mediaSingleElement: mediaSingleElement, isDrafting: isDrafting = false } = this.props;
            const annotationMarks = this.props.isAnnotationMark ? this.props.marks.filter(this.props.isAnnotationMark) : undefined;
            const borderMark = this.props.marks.find(this.props.isBorderMark);
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const eventHandlers = linkHref ? undefined : this.props.eventHandlers;
            const shouldOpenMediaViewer = !linkHref && allowMediaViewer;
            const isInPageInclude = mediaSingleElement?.closest('[data-node-type="include"]');
            const isIncludeExcerpt = !!mediaSingleElement?.closest('.ak-excerpt-include');
            const showCommentBadge = !!annotationMarks && !isInPageInclude && !isIncludeExcerpt;
            return /*#__PURE__*/ (0, $9K4OG.jsx)($9e8c139d238b6fc2$var$MediaLink, {
                mark: linkMark,
                onClick: this.handleMediaLinkClickFn
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($9e8c139d238b6fc2$var$MediaAnnotations, {
                marks: annotationMarks
            }, /*#__PURE__*/ (0, $9K4OG.jsx)($9e8c139d238b6fc2$var$MediaBorder, {
                mark: borderMark
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bYRk6.default), {
                data: {
                    [(0, $ffCOo.MEDIA_CONTEXT)]: {
                        border: !!borderMark
                    }
                }
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1xbL9.MediaBadges), {
                mediaElement: mediaSingleElement,
                mediaWidth: width,
                mediaHeight: height,
                useMinimumZIndex: true
            }, ({ visible: visible })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, visible && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4i54r.ExternalImageBadge), {
                    type: this.props.type,
                    url: this.props.type === 'external' ? this.props.url : undefined
                }), showCommentBadge && /*#__PURE__*/ (0, $9K4OG.jsx)($9e8c139d238b6fc2$var$CommentBadgeWrapper, {
                    marks: annotationMarks,
                    mediaSingleElement: mediaSingleElement,
                    isDrafting: isDrafting
                }))), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5l1kQ.MediaCard), {
                contextIdentifierProvider: contextIdentifierProvider,
                ...this.props,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                eventHandlers: eventHandlers,
                alt: allowAltTextOnImages ? alt : undefined,
                featureFlags: featureFlags,
                shouldEnableDownloadButton: enableDownloadButton,
                ssr: ssr
            })))));
        };
        this.handleMediaLinkClick = (event)=>{
            const { fireAnalyticsEvent: fireAnalyticsEvent, isLinkMark: isLinkMark, marks: marks } = this.props;
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $d925B.ACTION).VISITED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $59U23.PLATFORM).WEB,
                    mode: (0, $59U23.MODE).RENDERER
                }
            });
            const linkMark = this.props.marks.find(this.props.isLinkMark);
            const linkHref = linkMark?.attrs.href;
            const handler = (0, $b7FrM.getEventHandler)(this.props.eventHandlers, 'link');
            if (handler) {
                const linkMark = marks.find(isLinkMark);
                handler(event, linkMark && linkHref);
            }
        };
        this.handleMediaLinkClickFn = this.handleMediaLinkClick.bind(this);
    }
}
const $9e8c139d238b6fc2$var$MediaWithDraftAnnotation = (props)=>{
    const { hoverDraftDocumentPosition: draftPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    const { dataAttributes: dataAttributes } = props;
    const pos = dataAttributes && dataAttributes['data-renderer-start-pos'];
    const [position, setPosition] = (0, $42omo.useState)();
    const [shouldApplyDraftAnnotation, setShouldApplyDraftAnnotation] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (pos === undefined) return;
        const posToCheck = (draftPosition?.from ?? 0) + 1;
        if (draftPosition !== null && posToCheck === pos) {
            setShouldApplyDraftAnnotation(true);
            setPosition(posToCheck);
        } else if (draftPosition === null && shouldApplyDraftAnnotation) {
            setShouldApplyDraftAnnotation(false);
            setPosition(undefined);
        }
    }, [
        draftPosition,
        pos,
        shouldApplyDraftAnnotation
    ]);
    const applyDraftAnnotation = props.allowAnnotationsDraftMode && shouldApplyDraftAnnotation && position !== undefined;
    const dataAttributesWithDraftAnnotation = (0, $42omo.useMemo)(()=>applyDraftAnnotation ? {
            ...dataAttributes,
            'data-annotation-draft-mark': true,
            'data-renderer-mark': true
        } : dataAttributes, [
        applyDraftAnnotation,
        dataAttributes
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)($9e8c139d238b6fc2$var$Media, {
        ...props,
        dataAttributes: dataAttributesWithDraftAnnotation,
        isDrafting: shouldApplyDraftAnnotation
    });
};
var $9e8c139d238b6fc2$export$2e2bcd8739ae039 = $9e8c139d238b6fc2$var$MediaWithDraftAnnotation;
module.exports["default"] = $9e8c139d238b6fc2$export$2e2bcd8739ae039;

});

parcelRegister("5l1kQ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lcuos = parcelRequire("lcuos");


var $1BiXn = parcelRequire("1BiXn");

var $lasm3 = parcelRequire("lasm3");

var $9s7Po = parcelRequire("9s7Po");

var $8yFQr = parcelRequire("8yFQr");


var $3rvSa = parcelRequire("3rvSa");


var $8Doca = parcelRequire("8Doca");


var $1oCLl = parcelRequire("1oCLl");


var $6uN0A = parcelRequire("6uN0A");


var $d925B = parcelRequire("d925B");

const $c97c7f2b7cd82c79$export$7da2d00ddd5627a6 = new Map();
const $c97c7f2b7cd82c79$export$e689a46890560dbd = (doc)=>{
    if (!doc) return [];
    return (0, $lcuos.filter)(doc, (node)=>node.type === 'media').reduce((identifierList, mediaNode)=>{
        if (mediaNode.attrs) {
            const { type: type, url: dataURI, id: id } = mediaNode.attrs;
            if (type === 'file' && id) identifierList.push({
                mediaItemType: 'file',
                id: id
            });
            else if (type === 'external' && dataURI) identifierList.push({
                mediaItemType: 'external-image',
                dataURI: dataURI,
                name: dataURI
            });
        }
        return identifierList;
    }, []);
};
class $c97c7f2b7cd82c79$export$cfff5eb155a82d30 extends (0, $42omo.Component) {
    async componentDidMount() {
        const { rendererContext: rendererContext, contextIdentifierProvider: contextIdentifierProvider, id: id, url: url, collection: collectionName } = this.props;
        if (contextIdentifierProvider) this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        const nodeIsInCache = id && $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.has(id) || url && $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.has(url);
        if (rendererContext && rendererContext.adDoc && !nodeIsInCache) $c97c7f2b7cd82c79$export$e689a46890560dbd(rendererContext.adDoc).forEach((identifier)=>{
            if (identifier.mediaItemType === 'file' && identifier.id === id) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.set(identifier.id, {
                ...identifier,
                collectionName: collectionName
            });
            else if (identifier.mediaItemType === 'external-image') $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.set(identifier.dataURI, identifier);
        });
        if (id) this.saveFileState(id);
    }
    componentDidUpdate(prevProps) {
        const { id: oldId } = prevProps;
        if (this.props.id && oldId !== this.props.id) this.saveFileState(this.props.id);
    }
    componentWillUnmount() {
        const { id: id, url: dataURI } = this.props;
        if (id) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.delete(id);
        else if (dataURI) $c97c7f2b7cd82c79$export$7da2d00ddd5627a6.delete(dataURI);
    }
    renderExternal(shouldOpenMediaViewer) {
        const { cardDimensions: cardDimensions, resizeMode: resizeMode, appearance: appearance, url: url, imageStatus: imageStatus, disableOverlay: disableOverlay, alt: alt, featureFlags: featureFlags, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        if (imageStatus === 'loading' || !url) return this.renderLoadingCard();
        const identifier = {
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        };
        // we need this statement for the mandatory mediaClientConfig below
        const mediaClientConfig = mediaClient?.mediaClientConfig;
        const Card = enableSyncMediaCard ? (0, $8yFQr.default) : (0, $1BiXn.default);
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ...dataAttributes,
            "data-node-type": "media",
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Card, {
                // TODO: MPT-315 - clean up after we move mediaClientConfig into FileIdentifier
                // context is not really used when the type is external and we want to render the component asap
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mediaClientConfig: mediaClientConfig,
                alt: alt,
                identifier: identifier,
                dimensions: cardDimensions,
                appearance: appearance,
                resizeMode: resizeMode,
                disableOverlay: disableOverlay,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($c97c7f2b7cd82c79$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                ssr: ssr?.mode,
                shouldHideTooltip: false,
                onError: (0, $1oCLl.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
            })
        }));
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, fileState: fileState } = this.state;
        const { id: id, alt: alt, type: type, collection: collection, occurrenceKey: occurrenceKey, cardDimensions: cardDimensions, resizeMode: resizeMode, disableOverlay: disableOverlay, useInlinePlayer: useInlinePlayer, originalDimensions: originalDimensions, shouldOpenMediaViewer: forceOpenMediaViewer, featureFlags: featureFlags, shouldEnableDownloadButton: shouldEnableDownloadButton, ssr: ssr, mediaClient: mediaClient, dataAttributes: dataAttributes, enableSyncMediaCard: enableSyncMediaCard, localId: localId } = this.props;
        const isMobile = false;
        const shouldPlayInline = useInlinePlayer !== undefined ? useInlinePlayer : true;
        const isInlinePlayer = isMobile ? false : shouldPlayInline;
        const onCardClick = this.getOnCardClickCallback(isInlinePlayer);
        const shouldOpenMediaViewer = typeof forceOpenMediaViewer === 'boolean' ? forceOpenMediaViewer : !isMobile && !onCardClick;
        if (type === 'external') return this.renderExternal(shouldOpenMediaViewer);
        if (type === 'link') return null;
        const mediaClientConfig = !!ssr ? ssr.config : mediaClient?.mediaClientConfig;
        if (!mediaClientConfig || !id) return this.renderLoadingCard();
        if (!id || type !== 'file') return /*#__PURE__*/ (0, $l998X.jsx)((0, $lasm3.CardError), {
            dimensions: cardDimensions
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = {
            id: id,
            mediaItemType: 'file',
            collectionName: collection,
            occurrenceKey: occurrenceKey
        };
        const Card = enableSyncMediaCard ? (0, $8yFQr.default) : (0, $1BiXn.default);
        // Quick solution to disable lazy loading of images on PDF export pages in Confluence to remedy an issue with images never loading
        // More robust solution will be implemented as part of CCPDF-233 - Link: https://hello.jira.atlassian.cloud/browse/CCPDF-233
        const currentUrl = window.location.href;
        const shouldDisableLazyLoading = (0, $1oCLl.expValEquals)('platform_editor_disable_lazy_load_media', 'isEnabled', true) && currentUrl.includes('/wiki/pdf/spaces/');
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ...$c97c7f2b7cd82c79$export$92bef806f5be5d7c({
                id: id,
                alt: alt,
                collection: collection,
                contextIdentifierProvider: contextIdentifierProvider,
                originalDimensions: originalDimensions,
                fileState: fileState
            }),
            ...dataAttributes,
            "data-local-id": localId,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Card, {
                identifier: identifier,
                alt: alt,
                contextId: contextId,
                mediaClientConfig: mediaClientConfig,
                dimensions: cardDimensions,
                originalDimensions: originalDimensions,
                onClick: onCardClick,
                resizeMode: resizeMode,
                isLazy: !isMobile && !shouldDisableLazyLoading,
                disableOverlay: disableOverlay,
                useInlinePlayer: isInlinePlayer,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: Array.from($c97c7f2b7cd82c79$export$7da2d00ddd5627a6.values()),
                featureFlags: featureFlags,
                shouldEnableDownloadButton: shouldEnableDownloadButton,
                ssr: ssr?.mode,
                shouldHideTooltip: isMobile,
                onError: (0, $1oCLl.expValEquals)('platform_editor_media_error_analytics', 'isEnabled', true) ? this.onError : undefined
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {};
        this.saveFileState = async (id)=>{
            const { collection: collectionName, mediaClient: mediaClient } = this.props;
            const options = {
                collectionName: collectionName
            };
            try {
                if (mediaClient) {
                    const fileState = await mediaClient.file.getCurrentState(id, options);
                    this.setState({
                        fileState: fileState
                    });
                }
            } catch (error) {
            // do not set state on error
            }
        };
        this.onError = (reason)=>{
            this.props.fireAnalyticsEvent?.({
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).RENDERER,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).MEDIA,
                eventType: (0, $d925B.EVENT_TYPE).UI,
                attributes: {
                    reason: reason,
                    external: false
                }
            });
        };
        this.renderLoadingCard = ()=>{
            const { cardDimensions: cardDimensions } = this.props;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9s7Po.CardLoading), {
                dimensions: cardDimensions,
                interactionName: "renderer-media-card-loading"
            });
        };
        /**
     * We want to call provided `eventHandlers.media.onClick` when it's provided,
     * but we also don't want to call it when it's a video and inline video player is enabled.
     * This is due to consumers normally process this onClick call by opening media viewer and
     * we don't want that to happened described above text.
     */ this.getOnCardClickCallback = (isInlinePlayer)=>{
            const { eventHandlers: eventHandlers } = this.props;
            if (eventHandlers && eventHandlers.media && eventHandlers.media.onClick) return (result, analyticsEvent)=>{
                const isVideo = result.mediaItemDetails && result.mediaItemDetails.mediaType === 'video';
                const isVideoWithInlinePlayer = isInlinePlayer && isVideo;
                if (!isVideoWithInlinePlayer && eventHandlers && eventHandlers.media && eventHandlers.media.onClick) eventHandlers.media.onClick(result, analyticsEvent);
            };
            return undefined;
        };
    }
}
const $c97c7f2b7cd82c79$export$92bef806f5be5d7c = ({ id: id, alt: alt, collection: collection, contextIdentifierProvider: contextIdentifierProvider, originalDimensions: originalDimensions, fileState: fileState })=>{
    const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
    const width = originalDimensions && originalDimensions.width;
    const height = originalDimensions && originalDimensions.height;
    let fileName = 'file'; // default name is needed for Confluence
    let fileSize = 1;
    let fileMimeType = '';
    if (fileState && fileState.status !== 'error') {
        fileSize = fileState.size;
        fileName = fileState.name;
        fileMimeType = fileState.mimeType;
    }
    return {
        'data-context-id': contextId,
        'data-type': 'file',
        'data-node-type': 'media',
        'data-width': width,
        'data-height': height,
        'data-id': id,
        'data-collection': collection,
        'data-file-name': fileName,
        'data-file-size': fileSize,
        'data-file-mime-type': fileMimeType,
        'data-alt': alt
    };
};
const $c97c7f2b7cd82c79$export$fae4803d1ca121c8 = (props)=>{
    const mediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uN0A.default).Consumer, {
        children: ({ fireAnalyticsEvent: fireAnalyticsEvent })=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($c97c7f2b7cd82c79$export$cfff5eb155a82d30, {
                ...props,
                mediaClient: mediaClient,
                fireAnalyticsEvent: fireAnalyticsEvent
            });
        }
    });
};
const $c97c7f2b7cd82c79$export$a6543a2e3828db2c = (0, $8Doca.withImageLoader)($c97c7f2b7cd82c79$export$fae4803d1ca121c8);
module.exports["mediaIdentifierMap"] = $c97c7f2b7cd82c79$export$7da2d00ddd5627a6;
module.exports["getClipboardAttrs"] = $c97c7f2b7cd82c79$export$92bef806f5be5d7c;
module.exports["MediaCard"] = $c97c7f2b7cd82c79$export$a6543a2e3828db2c;

});

parcelRegister("lcuos", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $da92954c57c92ae9$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $da92954c57c92ae9$export$3dea766d36a8935f;

});

parcelRegister("lasm3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gUYJl = parcelRequire("gUYJl");


var $64ehG = parcelRequire("64ehG");


var $fDGbV = parcelRequire("fDGbV");

class $4d827ca5540b7b64$export$f7f7efdefcc02999 extends (0, $42omo.Component) {
    render() {
        const dimensions = (0, $fDGbV.getDimensionsWithDefault)(this.props.dimensions);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $64ehG.Wrapper), {
            dimensions: dimensions
        }, this.icon);
    }
    get icon() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gUYJl.ErrorIcon), null);
    }
}
module.exports["CardError"] = $4d827ca5540b7b64$export$f7f7efdefcc02999;

});

parcelRegister("gUYJl", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $ebrpi = parcelRequire("ebrpi");


var $deU3H = parcelRequire("deU3H");

class $cc3567b97db2e0fc$export$19bc16ee58e19b3d extends (0, $42omo.Component) {
    render() {
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $deU3H.errorIconWrapperStyles)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            color: "currentColor",
            label: "Error"
        })));
    }
}
module.exports["ErrorIcon"] = $cc3567b97db2e0fc$export$19bc16ee58e19b3d;

});

parcelRegister("deU3H", function(module, exports) {
function $1a717317aba342a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a717317aba342a5$export$8dcf6b831a37de79 = {
    name: "1fo963f",
    styles: "display:flex;color:var(--ds-icon-warning, #ff991f)"
};
module.exports["errorIconWrapperStyles"] = $1a717317aba342a5$export$8dcf6b831a37de79;

});

parcelRegister("8yFQr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $r0CCR = parcelRequire("r0CCR");

const $fae0b8a709d3e7ba$var$CardSync = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
        name: "media-card-sync",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $r0CCR.CardWithMediaClient), props));
};
var $fae0b8a709d3e7ba$export$2e2bcd8739ae039 = $fae0b8a709d3e7ba$var$CardSync;
module.exports["default"] = $fae0b8a709d3e7ba$export$2e2bcd8739ae039;

});

parcelRegister("eWRwJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4f3d8c1426d3d8$export$2e2bcd8739ae039);
var $ca4f3d8c1426d3d8$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<7d4381122b7da51c5a57a4c67758f949>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage) && ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true));
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !(0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') && !(0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || !contentId // avoid starting network flow
    });
    let serverModeRaw;
    if ((0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true)) {
        const contentProps = data?.content?.nodes?.[0]?.contentProperties;
        if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
        else serverModeRaw = contentProps?.latest?.contentMode;
    } else serverModeRaw = undefined;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $42omo.useMemo)(()=>({
            mode: mode,
            isLoading: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? Boolean(loading) : false,
            error: (0, $9wGTI.fg)('platform_editor_content_mode_button_mvp') || (0, $6mKj3.expValEquals)('confluence_compact_text_format', 'isEnabled', true) ? error ?? null : null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("5mB97", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $3e7bd247c2a15a57$var$_react = $3e7bd247c2a15a57$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $3e7bd247c2a15a57$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e7bd247c2a15a57$var$Document16Icon = (props)=>/*#__PURE__*/ $3e7bd247c2a15a57$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$3e7bd247c2a15a57$var$Document16Icon.displayName = 'Document16Icon';
var $3e7bd247c2a15a57$var$_default = module.exports.default = $3e7bd247c2a15a57$var$Document16Icon;

});

parcelRegister("i9cac", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d36280b20a14c4f7$var$_react = $d36280b20a14c4f7$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d36280b20a14c4f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d36280b20a14c4f7$var$Document24Icon = (props)=>/*#__PURE__*/ $d36280b20a14c4f7$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d36280b20a14c4f7$var$Document24Icon.displayName = 'Document24Icon';
var $d36280b20a14c4f7$var$_default = module.exports.default = $d36280b20a14c4f7$var$Document24Icon;

});

parcelRegister("j6GAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $90028f2cad692a01$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db70e40168178b4ae8431bb0df789052>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9RVmI = parcelRequire("9RVmI");


var $fP78j = parcelRequire("fP78j");

function $90028f2cad692a01$export$2e2bcd8739ae039({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
}

});

parcelRegister("fP78j", function(module, exports) {
$parcel$export(module.exports, "default", () => $fce53c8d1c9f5417$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $i7jPX = parcelRequire("i7jPX");

function $fce53c8d1c9f5417$export$2e2bcd8739ae039({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $dRnqM.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $i7jPX.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
}

});

parcelRegister("66dpz", function(module, exports) {
$parcel$export(module.exports, "default", () => $893c7e3925139b9a$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c9832fbd4a1ca0bae327cc20e7bdf16>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $kXb3C = parcelRequire("kXb3C");

function $893c7e3925139b9a$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kXb3C.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
}

});

parcelRegister("fAGae", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3b40ffeda05888$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a95f50e5543417b936016ac441fe40a9>>
 * @codegenCommand yarn build-glyphs
 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e0ycV = parcelRequire("e0ycV");


var $fP78j = parcelRequire("fP78j");

function $0f3b40ffeda05888$export$2e2bcd8739ae039({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fP78j.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
}

});

parcelRegister("6Eovk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d797c8c4e4c6494$export$2e2bcd8739ae039);
/* eslint-disable import/no-default-export */ /* eslint-disable react/prop-types */ 
var $42omo = parcelRequire("42omo");


var $cMypa = parcelRequire("cMypa");

function $4d797c8c4e4c6494$export$2e2bcd8739ae039(props) {
    // Produce the image tag as is because there is no onLoad event in SSR
    // Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
    // This will make image flicker
    return props.src && window.__SSR_RENDERED__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.loaded) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cMypa))), props);
}

});

parcelRegister("cMypa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94e4a7d853f8088a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $42omo = parcelRequire("42omo");

var $94e4a7d853f8088a$var$React = $94e4a7d853f8088a$var$_interopRequireWildcard($42omo);
function $94e4a7d853f8088a$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $94e4a7d853f8088a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94e4a7d853f8088a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94e4a7d853f8088a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $94e4a7d853f8088a$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $94e4a7d853f8088a$var$loaded() {
    return {
        isLoaded: true
    };
}
function $94e4a7d853f8088a$var$errored() {
    return {
        isErrored: true
    };
}
function $94e4a7d853f8088a$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $94e4a7d853f8088a$var$ImageRenderer = function(_React$Component) {
    $94e4a7d853f8088a$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $94e4a7d853f8088a$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $94e4a7d853f8088a$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($94e4a7d853f8088a$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $94e4a7d853f8088a$var$_possibleConstructorReturn(_this, _ret);
    }
    $94e4a7d853f8088a$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(this.props, nextProps)) this.setState($94e4a7d853f8088a$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($94e4a7d853f8088a$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($94e4a7d853f8088a$var$React.Component);
module.exports.default = $94e4a7d853f8088a$var$ImageRenderer;

});

parcelRegister("1Okf1", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dDhJe = parcelRequire("dDhJe");

const $6833d9101ef67c08$export$d08617a365fbe694 = (cardClient)=>(0, $42omo.useMemo)(()=>(0, $dDhJe.getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
        cardClient?.baseUrlOverride,
        cardClient?.envKey
    ]);
module.exports["useResolverUrl"] = $6833d9101ef67c08$export$d08617a365fbe694;

});

parcelRegister("8DZd1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $64b1721c286de662$var$_react = $64b1721c286de662$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $64b1721c286de662$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $64b1721c286de662$var$Generic16Icon = (props)=>/*#__PURE__*/ $64b1721c286de662$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$64b1721c286de662$var$Generic16Icon.displayName = 'Generic16Icon';
var $64b1721c286de662$var$_default = module.exports.default = $64b1721c286de662$var$Generic16Icon;

});

parcelRegister("djgQ6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9b0a1cae716cd1ca$var$_react = $9b0a1cae716cd1ca$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $9b0a1cae716cd1ca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9b0a1cae716cd1ca$var$Generic24Icon = (props)=>/*#__PURE__*/ $9b0a1cae716cd1ca$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9b0a1cae716cd1ca$var$Generic24Icon.displayName = 'Generic24Icon';
var $9b0a1cae716cd1ca$var$_default = module.exports.default = $9b0a1cae716cd1ca$var$Generic24Icon;

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("hL7bb", function(module, exports) {
var $cedc651d64f014e0$var$pSlice = Array.prototype.slice;

var $gFqzn = parcelRequire("gFqzn");


var $2EuUq = parcelRequire("2EuUq");

var $cedc651d64f014e0$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $cedc651d64f014e0$var$objEquiv(actual, expected, opts);
};
function $cedc651d64f014e0$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $cedc651d64f014e0$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $cedc651d64f014e0$var$objEquiv(a, b, opts) {
    var i, key;
    if ($cedc651d64f014e0$var$isUndefinedOrNull(a) || $cedc651d64f014e0$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($2EuUq(a)) {
        if (!$2EuUq(b)) return false;
        a = $cedc651d64f014e0$var$pSlice.call(a);
        b = $cedc651d64f014e0$var$pSlice.call(b);
        return $cedc651d64f014e0$var$deepEqual(a, b, opts);
    }
    if ($cedc651d64f014e0$var$isBuffer(a)) {
        if (!$cedc651d64f014e0$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $gFqzn(a), kb = $gFqzn(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$cedc651d64f014e0$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("gFqzn", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("2EuUq", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("i2CQL", function(module, exports) {

var $equi6 = parcelRequire("equi6");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $equi6.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("equi6", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $a80afd8c2b9b4a58$export$6ccbb43953eebf8);

var $l7KxQ = parcelRequire("l7KxQ");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $a80afd8c2b9b4a58$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $a80afd8c2b9b4a58$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = false;
const $a80afd8c2b9b4a58$var$identity = (arg)=>arg;
function $a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector = $a80afd8c2b9b4a58$var$identity, equalityFn) {
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$a80afd8c2b9b4a58$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = true;
    }
    const slice = $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $a80afd8c2b9b4a58$var$useDebugValue(slice);
    return slice;
}
const $a80afd8c2b9b4a58$var$createImpl = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $l7KxQ.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $a80afd8c2b9b4a58$export$185802fd694ee1f5 = (createState)=>createState ? $a80afd8c2b9b4a58$var$createImpl(createState) : $a80afd8c2b9b4a58$var$createImpl;
var $a80afd8c2b9b4a58$export$2e2bcd8739ae039 = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $a80afd8c2b9b4a58$export$185802fd694ee1f5(createState);
};

});


//# sourceMappingURL=media.f7e5b5ad.js.map
